import { DEFAULT_CURRENCY, TRIAL_DURATION_TYPES } from '@weft/types';
import type { DeepPartial } from 'react-hook-form';
import type { InvoiceFormInput } from '../create-invoice-form-types/invoice-form-input';

export const CREATE_INVOICE_DEFAULT_VALUES: DeepPartial<InvoiceFormInput> = {
  fixedProducts: [],
  usageProducts: [],
  settings: {
    currency: DEFAULT_CURRENCY,
    startPeriod: new Date().toISOString(),
    paymentDueDays: 0,
    trialPeriod: {
      duration: 0,
      type: TRIAL_DURATION_TYPES.months,
    },
  },
};